const US_STATES = [
  { 'Description': 'Alabama', 'Code': 'AL' },
  { 'Description': 'Alaska', 'Code': 'AK' },
  { 'Description': 'Arizona', 'Code': 'AZ' },
  { 'Description': 'Arkansas', 'Code': 'AR' },
  { 'Description': 'California', 'Code': 'CA' },
  { 'Description': 'Colorado', 'Code': 'CO' },
  { 'Description': 'Connecticut', 'Code': 'CT' },
  { 'Description': 'Delaware', 'Code': 'DE' },
  { 'Description': 'District of Columbia', 'Code': 'DC' },
  { 'Description': 'Florida', 'Code': 'FL' },
  { 'Description': 'Georgia', 'Code': 'GA' },
  { 'Description': 'Hawaii', 'Code': 'HI' },
  { 'Description': 'Idaho', 'Code': 'ID' },
  { 'Description': 'Illinois', 'Code': 'IL' },
  { 'Description': 'Indiana', 'Code': 'IN' },
  { 'Description': 'Iowa', 'Code': 'IA' },
  { 'Description': 'Kansa', 'Code': 'KS' },
  { 'Description': 'Kentucky', 'Code': 'KY' },
  { 'Description': 'Lousiana', 'Code': 'LA' },
  { 'Description': 'Maine', 'Code': 'ME' },
  { 'Description': 'Maryland', 'Code': 'MD' },
  { 'Description': 'Massachusetts', 'Code': 'MA' },
  { 'Description': 'Michigan', 'Code': 'MI' },
  { 'Description': 'Minnesota', 'Code': 'MN' },
  { 'Description': 'Mississippi', 'Code': 'MS' },
  { 'Description': 'Missouri', 'Code': 'MO' },
  { 'Description': 'Montana', 'Code': 'MT' },
  { 'Description': 'Nebraska', 'Code': 'NE' },
  { 'Description': 'Nevada', 'Code': 'NV' },
  { 'Description': 'New Hampshire', 'Code': 'NH' },
  { 'Description': 'New Jersey', 'Code': 'NJ' },
  { 'Description': 'New Mexico', 'Code': 'NM' },
  { 'Description': 'New York', 'Code': 'NY' },
  { 'Description': 'North Carolina', 'Code': 'NC' },
  { 'Description': 'North Dakota', 'Code': 'ND' },
  { 'Description': 'Ohio', 'Code': 'OH' },
  { 'Description': 'Oklahoma', 'Code': 'OK' },
  { 'Description': 'Oregon', 'Code': 'OR' },
  { 'Description': 'Pennsylvania', 'Code': 'PA' },
  { 'Description': 'Rhode Island', 'Code': 'RI' },
  { 'Description': 'South Carolina', 'Code': 'SC' },
  { 'Description': 'South Dakota', 'Code': 'SD' },
  { 'Description': 'Tennessee', 'Code': 'TN' },
  { 'Description': 'Texas', 'Code': 'TX' },
  { 'Description': 'Utah', 'Code': 'UT' },
  { 'Description': 'Vermont', 'Code': 'VT' },
  { 'Description': 'Virginia', 'Code': 'VA' },
  { 'Description': 'Washington', 'Code': 'WA' },
  { 'Description': 'West Virginia', 'Code': 'WV' },
  { 'Description': 'Wisconsin', 'Code': 'WI' },
  { 'Description': 'Wyoming', 'Code': 'WY' },
];

export default US_STATES;